import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      original: "Œuvres originales",
      tapestry: "Tapisserie",
      about: "À propos",
      aboutIt: "Infos",
      expo: "Expo",
      contact: "Contact",
    },
    sold: "Vendue",
    enquire: "Commander",
    enquireMsg: "Bonjour Jeanne, je suis intéressée par l'œuvre « {title} ». ",
    hero: {
      kicker: "Jeanne Leveque — Artiste française à Sydney",
      line1: "What a wonderful",
      line2: "Wall…",
      line3: "World.",
      sub: "Entre peinture traditionnelle et création digitale, j'aime transformer les murs pour qu'ils soient vus.",
      cta: "Voir les œuvres",
      caption: "DAY 2 — tapisserie, lin & coton",
    },
    marquee: "Entre peinture traditionnelle et création digitale, j'aime transformer les murs pour qu'ils soient vus",
    original: {
      num: "01",
      title: "Œuvres originales",
      note: "Peintures originales — pièces uniques",
    },
    tapestry: {
      num: "02",
      title: "Tapisserie contemporaine",
      note: "Limited edition — Lin & coton naturels, quatre œillets métalliques",
      sizesIntro: "Trois tailles :",
      sizes: [
        { label: "S", dim: "60 × 85 cm", price: "150 AUD" },
        { label: "M", dim: "90 × 130 cm", price: "260 AUD" },
        { label: "L", dim: "125 × 170 cm", price: "300 AUD" },
        { label: "L — Extérieur", dim: "toile en bambou ciré (exemple en DAY 2)", price: "500 AUD" },
      ],
    },
    about: {
      num: "03",
      title: "À propos de moi",
      p1: "Je suis une artiste française basée à Sydney. Inspirée par les femmes qui m'entourent, mes voyages, la musique, et nostalgique de l'esthétique mid-century, je crée des œuvres où les courbes féminines se mêlent à la couleur pour capturer l'énergie d'une femme aux cheveux relevés en chignon.",
      p2: "À travers des peintures originales ou digitales sur papier, toile et tissus de lin et coton rappelant les tapisseries contemporaines, mon travail transforme les espaces par sa simplicité graphique audacieuse et sa douceur vibrante et élégante.",
      p3: "What a wonderful wall… World.",
      caption: "Dans l'atelier — Sydney",
    },
    aboutIt: {
      num: "04",
      title: "Infos pratiques",
      note: "Matières, entretien & livraison",
      items: [
        {
          q: "Matières",
          a: "Œuvres originales : peintes à l'acrylique sur papier épais, toile et tissus naturels en coton et lin.\n\nTapisseries imprimées : tissu naturel de lin et coton, avec quatre œillets métalliques aux coins.\n\nTapisseries pour l'extérieur : toile de bambou ciré, avec trois œillets métalliques dorés sur chaque côté.\n\nNotez que les couleurs réelles peuvent varier légèrement de ce qui apparaît à l'écran, en raison des réglages d'écran, des procédés d'impression et du tissu organique naturel.",
        },
        {
          q: "Peut-on repasser la tapisserie ?",
          a: "Oui. Comme elle arrive pliée dans un sac, je vous conseille de la repasser sur l'envers pour faire disparaître les plis.",
        },
        {
          q: "Peut-on laver la tapisserie ?",
          a: "Oui, je recommande un lavage à 30 degrés.",
        },
        {
          q: "Livraison",
          a: "Chaque pièce est préparée avec soin à l'atelier de Sydney, puis expédiée dans le monde entier. Les délais et frais sont confirmés par email après votre demande. Le délai de livraison en Australie est d'environ 1 à 3 semaines.\n\nPour les livraisons hors Australie : les frais d'expédition n'incluent pas les droits de douane ni les taxes (dont la TVA) qui peuvent être appliqués à l'arrivée dans votre pays. Ils restent à votre charge.\n\nL'écologie fait partie intégrante de ma pratique — jusqu'à l'emballage. Mes tapisseries voyagent dans des enveloppes en coton naturel, puis dans des pochettes à bulles conçues par BetterPackaging à partir de plastique océanique recyclé.\n\nPour que le voyage de chaque œuvre soit aussi responsable que sa création.",
          imgs: ["/images/packaging-1.webp", "/images/packaging-2.webp"],
        },
        {
          q: "Retours & remboursements",
          a: "Toutes les ventes sont finales. Je rembourse l'achat uniquement si la tapisserie ou l'œuvre originale a été endommagée pendant le transport.",
        },
        {
          q: "Conditions générales",
          a: "Chaque œuvre originale est peinte par Jeanne Leveque et accompagnée d'un certificat d'authenticité signé.\n\nLes tapisseries sont réalisées avec des matériaux de haute qualité ; les couleurs peuvent varier légèrement selon les procédés d'impression et les tissus. Elles sont également accompagnées d'un certificat d'authenticité.\n\nToutes les œuvres originales et la collection de tapisseries restent la propriété intellectuelle de l'artiste — elles ne peuvent être copiées, scannées ni reproduites.",
        },
      ],
    },
    expo: {
      num: "05",
      title: "Expositions",
      note: "Sélection — passées & à venir",
      intro: "Mon parcours artistique m'a déjà menée en France il y a dix ans, où j'ai organisé une exposition dont toutes les œuvres ont été vendues — une belle reconnaissance du lien que mon travail peut créer avec les gens.",
      upcoming: "À venir",
      past: "Passée",
      items: [
        { year: "2016", title: "Huit-Sept", place: "Limoges, France — toutes les œuvres vendues", status: "past" },
      ],
    },
    contact: {
      num: "06",
      title: "Écrivons-nous",
      note: "Commandes, collaborations & questions",
      name: "Votre nom",
      email: "Votre email",
      message: "Votre message",
      send: "Envoyer",
      sending: "Envoi…",
      success: "Message envoyé — merci ! Je vous réponds très vite.",
      error: "Une erreur est survenue. Réessayez ou écrivez directement à jeanne.leveque.m@gmail.com",
    },
    footer: {
      tag: "What a wonderful Wall… World.",
      rights: "Tous droits réservés",
      made: "France — Australie",
    },
  },
  en: {
    nav: {
      home: "Home",
      original: "Original Work",
      tapestry: "Tapestry",
      about: "About Me",
      aboutIt: "About It",
      expo: "Expo",
      contact: "Contact",
    },
    sold: "Sold",
    enquire: "Enquire",
    enquireMsg: "Hello Jeanne, I'm interested in the piece \"{title}\". ",
    hero: {
      kicker: "Jeanne Leveque — French artist based in Sydney",
      line1: "What a wonderful",
      line2: "Wall…",
      line3: "World.",
      sub: "Between traditional painting and digital creation, I like to transform walls to be seen.",
      cta: "View the work",
      caption: "DAY 2 — tapestry, linen & cotton",
    },
    marquee: "Between traditional painting and digital creation, I like to transform walls to be seen",
    original: {
      num: "01",
      title: "Original Work",
      note: "Original paintings — one-of-a-kind pieces",
    },
    tapestry: {
      num: "02",
      title: "Contemporary Tapestry",
      note: "Limited edition — Natural linen & cotton fabric, four metal eyelets",
      sizesIntro: "Three sizes:",
      sizes: [
        { label: "S", dim: "60 × 85 cm", price: "150 AUD" },
        { label: "M", dim: "90 × 130 cm", price: "260 AUD" },
        { label: "L", dim: "125 × 170 cm", price: "300 AUD" },
        { label: "L — Outdoor", dim: "waxed bamboo canvas (example shown in DAY 2)", price: "500 AUD" },
      ],
    },
    about: {
      num: "03",
      title: "About Me",
      p1: "I am a French artist based in Sydney. Inspired by the women around me, my travels, music and nostalgic for mid-century aesthetics, I create works where feminine curves blend with colour to capture the energy of a woman with her hair in a bun.",
      p2: "Through original or digital paintings on paper, canvas, and linen/cotton fabrics reminiscent of contemporary tapestries, my work is capable of transforming spaces with its bold graphic simplicity and vibrant, elegant softness.",
      p3: "What a wonderful wall… World.",
      caption: "In the studio — Sydney",
    },
    aboutIt: {
      num: "04",
      title: "About It",
      note: "Materials, care & shipping",
      items: [
        {
          q: "Materials",
          a: "Original works: painted in acrylic on thick paper, canvas and natural cotton & linen fabrics.\n\nPrinted tapestries: natural linen and cotton fabric with four metal eyelets on each corner.\n\nOutdoor tapestries: waxed bamboo canvas, with three gold metal eyelets on each side.\n\nPlease note that the colours of actual prints may vary slightly from what appears on your screen due to differences in monitor settings, printing processes and the natural organic fabric.",
        },
        {
          q: "Can we iron the tapestry?",
          a: "Yes, because it comes folded in a bag, I suggest you iron it on the back to remove the creases.",
        },
        {
          q: "Can we wash the tapestry?",
          a: "Yes, I recommend 30 degrees.",
        },
        {
          q: "Shipping & delivery",
          a: "Each piece is prepared with care in the Sydney studio, then shipped worldwide. Times and costs are confirmed by email after your enquiry. The domestic shipping time is around 1-3 weeks.\n\nNon Aussie, please note that shipping rates do not include customs or duties (taxes including VAT) that may be charged once it reaches your country. They are your responsibility.\n\nSustainability is part of my practice — all the way to the packaging. My tapestries travel in natural cotton envelopes, then in bubble mailers made by BetterPackaging from recycled ocean-bound plastic.\n\nSo the journey of each artwork is as conscious as its creation.",
          imgs: ["/images/packaging-1.webp", "/images/packaging-2.webp"],
        },
        {
          q: "Return & refund policy",
          a: "All sales are final. I refund the purchase only if the tapestry or original is damaged from the shipping.",
        },
        {
          q: "Terms & conditions",
          a: "Each original is painted by Jeanne Leveque and comes with a signed certificate of authenticity.\n\nTapestries are made with high quality materials and colours may vary slightly due to print processes and fabrics. They also have a certificate of authenticity.\n\nAll originals and tapestries collection remain the copyright of the artist, they may not be copied, scanned or reproduced.",
        },
      ],
    },
    expo: {
      num: "05",
      title: "Exhibitions",
      note: "Selected — past & upcoming",
      intro: "My artistic journey has already taken me to France 10 years ago, where I held an exhibition in which every artwork was sold — a beautiful recognition of the connection my work can create with people.",
      upcoming: "Upcoming",
      past: "Past",
      items: [
        { year: "2016", title: "Huit-Sept", place: "Limoges, France — all artworks sold", status: "past" },
      ],
    },
    contact: {
      num: "06",
      title: "Let's Talk",
      note: "Commissions, collaborations & questions",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send",
      sending: "Sending…",
      success: "Message sent — thank you! I'll get back to you very soon.",
      error: "Something went wrong. Please try again or write directly to jeanne.leveque.m@gmail.com",
    },
    footer: {
      tag: "What a wonderful Wall… World.",
      rights: "All rights reserved",
      made: "France — Australia",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
